
            const data = {"name":"spinner","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M2.873 16.09A9.957 9.957 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10c-2.41 0-4.62-.853-6.347-2.272\" _stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\"/>"}}
        
                module.exports = data
                